function t(){t=Object.assign?Object.assign.bind():function(t){for(var r=1;r<arguments.length;r++){var n=arguments[r];for(var a in n){if(Object.prototype.hasOwnProperty.call(n,a)){t[a]=n[a]}}}return t};return t.apply(this,arguments)}export{t as default};
//# sourceMappingURL=extends.js.map
